var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextRole(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_3071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1922 2.5H4.8077C3.5332 2.5 2.5 3.5332 2.5 4.8077V30.1922C2.5 31.4667 3.5332 32.5 4.8077 32.5H30.1922C31.4667 32.5 32.5 31.4667 32.5 30.1922V4.8077C32.5 3.5332 31.4667 2.5 30.1922 2.5Z",
    fill: "#79EE8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0625 8.79597V30.1922C4.0625 30.6037 4.39613 30.9375 4.8077 30.9375H30.1922C30.6037 30.9375 30.9375 30.6037 30.9375 30.1922V8.79597H4.0625ZM4.8077 0.9375C2.67025 0.9375 0.9375 2.67025 0.9375 4.8077V30.1922C0.9375 32.3298 2.67025 34.0625 4.8077 34.0625H30.1922C32.3298 34.0625 34.0625 32.3298 34.0625 30.1922V4.8077C34.0625 2.67025 32.3298 0.9375 30.1922 0.9375H4.8077ZM25.6098 13.5889C26.389 14.2708 26.468 15.4554 25.7862 16.2347L17.0361 26.2348C16.3903 26.9728 15.2847 27.0885 14.5001 26.5L9.50007 22.75C8.67165 22.1287 8.50375 20.9534 9.12507 20.125C9.7464 19.2966 10.9216 19.1287 11.7501 19.75L15.359 22.4567L22.964 13.7653C23.6459 12.986 24.8305 12.907 25.6098 13.5889Z",
    fill: "#0C098C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_3071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextRole);
export default __webpack_public_path__ + "static/media/NextRole.59b46d05756ff00e5f443959dffbaee1.svg";
export { ForwardRef as ReactComponent };